import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { AssignedAccountsComponent } from '@irb/irb-clients/assigned-accounts/assigned-accounts.component';
import {IrbClientsEvents} from '@irb-common/events';
import { AppService } from '@irb/app.service';
import {GlobalCashCellRendererComponent} from "@irb/irb-clients/assigned-accounts/global-cash-cell.renderer.component";
import { IrbAgSearchMultipleColumnFilterComponent } from '@irb/irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-search-multiple-column-filter/irb-ag-search-multiple-column-filter.component';

@Injectable({
    providedIn: 'root'
})
export class AssignedAccountsGridLayoutService implements GridLayoutService<AssignedAccountsComponent> {
    constructor(private as: AppService) {}

    getFrameworkComponents() {
        return {
        };
    }

    getColumnDefs(parent: AssignedAccountsComponent) {
        let a: Array<any> = [{
            headerName: 'Select All',
            headerComponent: 'customHeader',
            cellRenderer: 'customHeader',
            cellRendererParams: { parentObject: parent, type: 'rowCheckBox' },
            suppressColumnsToolPanel: true,
            suppressFiltersToolPanel: true,
            suppressSizeToFit: true,
            toolPanelClass: 'toolpanel-header-checkbox-hide',
            headerComponentParams: { parentObject: parent, type: 'headerCheckBox' },
            floatingFilterComponent: 'customHeader',
            floatingFilterComponentParams: { parentObject: parent, type: 'NoClearAllBtn' },
            suppressFloatingFilterButton: true,
            pinned: 'left',
            suppressMovable: true,
            lockPosition: true,
            lockVisible: true,
            sortable: false,
            filter: true,
            resizable: false,
            minWidth: 24,
            width: 24,
            maxWidth:24,
            cellStyle: { 'padding': '5px 3px 0 2px' },
            headerClass: 'customHeaderClassSelectAll',
            cellClass: 'selectAllCheckBoxRecord'
        },
        {
            headerName: 'Account',
            field: 'accountNumber',
            sort: 'asc',
            minWidth: 80,
            maxWidth: 140,
            pinned: 'left',
            cellClassRules: {
                'add-pointer': (params: any) => {
                    return (params.value != null && params.value.length > 0);
                }
            },
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null && params.value.length > 0);
                },
                onClick: (function (data: any) {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: data });
                }).bind(this),
                calltoactionTemplateFunc: parent.ENABLE_FLYOUT ? (params: any) => parent.getTemplate(params) : undefined
            },
            floatingFilterComponent: 'irbInputFloatingFilterComponent',
            suppressFiltersToolPanel: true,
            filter: 'irbAgSearchMultipleColumnFilterComponent',
            filterParams: {
                search: (str: string, d: IrbAgSearchMultipleColumnFilterComponent) => parent.getAssignedAccountNumber(str, d),
                threshold: 3,
                field: "accountNumber",
                enableHiddenSearchResults: true
            },
            lockPosition: true,
            lockVisible: true
        },
        {
            headerName: 'Name',
            field: 'accountName',
            minWidth: 140,
            cellRenderer: 'cellRendererFormatter',
            floatingFilterComponent: 'irbInputFloatingFilterComponent',
            suppressFiltersToolPanel: true,
            filter: 'irbAgSearchMultipleColumnFilterComponent',
            filterParams: {
                search: (str: string, d: IrbAgSearchMultipleColumnFilterComponent) => parent.getAssignedAccountName(str, d),
                threshold: 2,
                field: "accountId",
                displayField: "name",
                enableHiddenSearchResults: true
            }
        },
        {
            headerName: 'Type',
            field: 'accountsubType',
            maxWidth: 160,
            cellRenderer: 'cellRendererFormatter',
            suppressFiltersToolPanel: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons:['reset', 'apply'],
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                closeOnApply: true,
                refreshValuesOnOpen: true,
                values: (params: any) => {
                    params.success(parent.accountSubTypeList);
                },
            },
            minWidth: 80
        },
        {
            headerName: 'Taxability',
            field: 'accountLocationType',
            maxWidth: 130,
            cellRenderer: 'cellRendererFormatter',
            suppressFiltersToolPanel: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons:['reset', 'apply'],
                newRowsAction: 'keep',
                suppressSorting: true,
                refreshValuesOnOpen: true,
                cellHeight: 30,
                closeOnApply: true,
                suppressMiniFilter: true,
                values: (params: any) => {
                    params.success(parent.accountLocationTypeList);
                },
            },
            minWidth: 80
        },
        {
            headerName: 'Master Account', //RepCode change to master as per schwab standards
            field: 'masterAccount',
            maxWidth: 160,
            cellRenderer: 'cellRendererFormatter',
            suppressFiltersToolPanel: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons:['reset', 'apply'],
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                closeOnApply: true,
                refreshValuesOnOpen: true,
                values: (params: any) => {
                    params.success(parent.masterAccountList);
                },
            },
            minWidth: 80
        },
        {
            headerName: 'Market Value',
            headerComponentParams: {
                irbColInfo: this.valueColInfo()
            },
            field: 'marketValue',
            maxWidth: 160,
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: { type: 'currency' },
            suppressFiltersToolPanel: true,
            filter: 'irbAgNumberColumnFilterComponent',
            floatingFilterComponent: 'irbInputFloatingFilterComponent',
            minWidth: 80
        },
        {
            headerName: 'Portfolio',
            field: 'portfolio',
            minWidth: 140,
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null && params.value.length > 0);
                },
                onClick: (function (data: any) {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, { data: data });
                }).bind(this)
            },
            suppressFiltersToolPanel: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons:['reset', 'apply'],
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                showTooltips: true,
                refreshValuesOnOpen: true,
                closeOnApply: true,
                values: (params: any) => {
                    params.success(parent.portfolioNameValuesList);
                },
            }
        },
        {
            headerName: 'Model',
            field: 'modelName',
            filter: 'agSetColumnFilter',
            minWidth: 140,
            cellRendererSelector:(params: any) => this.formatModelData(params),
            suppressFiltersToolPanel: true,
            filterParams: {
                buttons:['reset', 'apply'],
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                showTooltips: true,
                refreshValuesOnOpen: true,
                closeOnApply: true,
                values: (params: any) => {
                    params.success(parent.modelNameValuesList);
                },
            }
        },
        {
            headerName: 'ST G/L',
            headerComponentParams: {
                irbColInfo: this.aggregatedYTDSTColInfo()
            },
            field: 'shortTermGainLoss',
            cellStyle:this.cellStyleEmpty,
            cellRendererSelector:(params: any) => this.formatGainLossData(params),
            maxWidth: 140
        },
        {
            headerName: 'LT G/L',
            headerComponentParams: {
                irbColInfo: this.aggregatedYTDLTColInfo()
            },
            field: 'longTermGainLoss',
            cellStyle:this.cellStyleEmpty,
            cellRendererSelector:(params: any) => this.formatGainLossData(params),
            maxWidth: 140
        },
        {
            headerName: 'YTD G/L',
            headerComponentParams: {
                irbColInfo: this.aggregatedYTDTotalColInfo()
            },
            field: 'totalGainLoss',
            cellStyle:this.cellStyleEmpty,
            cellRendererSelector:(params: any) => this.formatGainLossData(params),
            maxWidth: 140
        },
        {
            headerName: 'Glbl Cash',
            field: 'isGlobal',
            cellStyle: { 'text-align': 'center' },
            cellRenderer: GlobalCashCellRendererComponent,
            cellRendererParams: {
                onClick: (function (data: any) {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: data,source:"cshNeeds" });
                }).bind(this)
            },
            maxWidth: 140
        },
        {
            headerName: 'Cash Min',
            field: 'cashMinimum',
            cellStyle: this.cellStyleDollar,
            cellClassRules: {
                'negative-cell-link': (params: any) => {
                    return parent.getCashMinimum(params)?.startsWith("(");
                }
            },
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null && params.value.length > 0 && !params.data?.isGlobal && !params.data?.isSMA);
                },
                onClick: (function (data: any) {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, {data: data, source: "cshNeeds"});
                }).bind(this)
            },
            cellRendererSelector: (params: any) => {
                let finalValue = parent.getCashMinimum(params);
                return {
                    component: 'cellRendererFormatter',
                    params: {value: finalValue}
                };
            },
            maxWidth: 140
        },
        {
            headerName: 'Cash Target',
            field: 'cashTarget',
            cellStyle: this.cellStyleDollar,
            cellClassRules: {
                'negative-cell-link': (params: any) => {
                    return parent.getCashTarget(params)?.startsWith("(");
                }
            },
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null && params.value.length > 0 && !params.data?.isGlobal && !params.data?.isSMA);
                },
                onClick: (function (data: any) {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: data,source:"cshNeeds" });
                }).bind(this)
            },
            cellRendererSelector: (params: any) => {
                let finalValue = parent.getCashTarget(params);
                return {
                    component: 'cellRendererFormatter',
                    params: {value: finalValue}
                };
            },
            maxWidth: 140
        },
        {
            headerName: 'Cash Max',
            field: 'cashMaximum',
            cellStyle: this.cellStyleDollar,
            cellClassRules: {
                'negative-cell-link': (params: any) => {
                    return parent.getCashMaximum(params)?.startsWith("(");
                }
            },
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null && params.value.length > 0 && !params.data?.isGlobal && !params.data?.isSMA);
                },
                onClick: (function (data: any) {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: data,source:"cshNeeds" });
                }).bind(this)
            },
            cellRendererSelector: (params: any) => {
                let finalValue = parent.getCashMaximum(params);
                return {
                    component: 'cellRendererFormatter',
                    params: {value: finalValue}
                };
            },
            maxWidth: 140
        },
        {
            headerName: 'Set Aside Amt',
            field: 'curAmount',
            cellStyle: this.cellStyleDollar,
            cellClassRules: {
                'negative-cell-link': (params: any) => {
                    if (params.value && (params.value.includes("-") || params.value.includes("("))) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            cellRendererSelector: (params: any) => {
                let finalValue = params.data?.isSMA ? 'n/a' : parent.roundDollarString(params.data?.curAmount);
                return {
                    component: 'cellRendererFormatter',
                    params: {value: finalValue}
                };
            },
            cellRendererParams: {
                link: (params: any) => {
                    return (params.value != null && params.value.length > 0 && !params.data?.isGlobal && !params.data?.isSMA);
                },
                onClick: (function (data: any) {
                    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_ACCOUNT, { data: data,source:"cshNeeds" });
                }).bind(this)
            },
            maxWidth: 180
        }];

        if(parent.isDistHoldCashEnabled) {
            a.push({
                headerName: 'Dist Hold',
                field: 'autoCashHoldForDistAmt',
                maxWidth: 140,
                minWidth: 80,
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: { type: 'currency' },
                filter: 'irbAgNumberColumnFilterComponent',
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                hide: true
            });
        }

        a = a.concat([{
            headerName: 'Div Reinvest',
            field: 'isDividendReinvest',
            cellRenderer: (params: any) => this.checkOrDash(params),
            cellClass: 'center',
            editable: false,
            maxWidth: 140
        },
        {
            headerName: 'CG Reinvest',
            field: 'isCapGainsReinvest',
            cellRenderer: (params: any) => this.checkOrDash(params),
            cellClass: 'center',
            editable: false,
            maxWidth: 140
        },
        {
            headerName: 'Frozen',
            field: 'isDoNotTrade',
            cellRenderer: (params: any) => this.checkOrDash(params),
            cellClass: 'center',
            editable: false,
            maxWidth: 120
        },
        {
            headerName: 'External Account',
            field: 'isExternalAccount',
            cellRenderer: (params: any) => this.checkOrDash(params),
            cellClass: 'center',
            editable: false,
            hide: !parent.dataTransferService.ShowExternalAccounts,
            suppressColumnsToolPanel: !parent.dataTransferService.ShowExternalAccounts,
            maxWidth: 180
        },
        {
            headerName: 'SMA Symbol',
            field: 'smaSymbolName',
            hide: !parent.dataTransferService.ShowSMASymbol,
            suppressColumnsToolPanel: !parent.dataTransferService.ShowSMASymbol,
            cellRenderer: "cellRendererFormatter",
            maxWidth: 150
        },
        {
            field: 'cashSymbol',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'setAsideSymbol',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'nextScheduleDate',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'fundingAccountNumber',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'isDividendReinvestFormatted',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'isCapGainsReinvestFormatted',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'isDoNotTradeFormatted',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'cashMinimumFloat',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'cashMaximumFloat',
            hide: true,
            suppressColumnsToolPanel: true
        },
        {
            field: 'curAmountFloat',
            hide: true,
            suppressColumnsToolPanel: true
        }]);

        return a;
    }

    formatGainLossData(params:any){
        if (params && params.value) {
            return {             
              component: 'cellRendererFormatter',  
              params:{value:params.value, type: 'currency'}  
             }
        }else {
            return {              
                component: 'cellRendererFormatter',  
                params:{value:'--'}        
              }
          }
    }

    formatModelData(params:any){
        if (params && params.value) {
            return {
                component: 'cellRendererFormatter'
            }
        }else {
            return {
                component: 'cellRendererFormatter',
                params:{ template: `<span class="none-value">none</span>`}
            }

        }
    }

    cellStyleDollar(params: any) {
        if (params.value && (params.value.includes("-") || params.value.includes("("))) {
            //mark police cells as red
            return { color: '#D30014', 'text-align': 'right' };
        } else {
            return { 'text-align': 'right' };
        }
    }

    cellStyleEmpty(params: any) {
        // empty cell to align center
        if (!(params && params.value)) {
            return { 'text-align': 'center' };
        }
    }

    valueColInfo(){
        return `
        <p>The market value shown for the account is the start of day value.</p>
        `
    }

    restrictionsColInfo(){
        return `
        <p>You can set portfolio-level security restrictions. These restrictions will override any that are set for a security in the security master or in the portfolio's assigned model.</p>
        `
    }

    aggregatedYTDSTColInfo(){
        return `
        <p>The realized year-to-date short term gain/loss for this account is the start of day value.</p>
        `
    }

    aggregatedYTDLTColInfo(){
      return `
      <p>The realized year-to-date long term gain/loss for this account is the start of day value.</p>
      `
    }

    aggregatedYTDTotalColInfo(){
        return `
        <p>The realized year-to-date total gain/loss for this account is the start of day value.</p>
        `
    }

    getDefaultHiddenState(parent: AssignedAccountsComponent, fieldName: string, defaultState: boolean) {
        let s: any = JSON.parse(window.localStorage.getItem(parent.componentName) || "{}");

        if(s.COL_STATE) {
            let c: any  = JSON.parse(s.COL_STATE);

            if(c) {
                let d = c.find((x: any) => x.colId === fieldName);
                return d?.hide;
            }
        }

        return defaultState;
    }

    getColumnLimits() {
        return {
            columnLimits: [
                { key: 'accountNumber', minWidth: 100 },
                { key: 'accountName', minWidth: 150 },
                { key: 'accountsubType', minWidth: 130 },
                { key: 'accountLocationType', minWidth: 95 },
                { key: 'masterAccount', minWidth: 120 },
                { key: 'marketValue', minWidth: 128 },
                { key: 'portfolio', minWidth: 160 },
                { key: 'modelName', minWidth: 150 },
                { key: 'shortTermGainLoss', minWidth: 85 },
                { key: 'longTermGainLoss', minWidth: 85 },
                { key: 'totalGainLoss', minWidth: 90 },
                { key: 'isGlobal', minWidth: 85 },
                { key: 'cashMinimum', minWidth: 88 },
                { key: 'cashTarget', minWidth: 98 },
                { key: 'cashMaximum', minWidth: 91 },
                { key: 'trxCashMinSetting', minWidth: 134 },
                { key: 'trxCashMinValue', minWidth: 112 },
                { key: 'curAmount', minWidth: 110 },
                { key: 'autoCashHoldForDistAmt', minWidth: 91 },
                { key: 'isDividendReinvest', minWidth: 102 },
                { key: 'isCapGainsReinvest', minWidth: 102 },
                { key: 'isDoNotTrade', minWidth: 70 },
                { key: 'isExternalAccount', minWidth: 129 },
                { key: 'smaSymbolName', minWidth: 102 }
            ]
        }
    }

    checkOrDash(params: any) {
        if (params.value)
            return '<img src="./assets/images/success.png">';
        else
            return '--'
    }
}
